import Vue from "vue";
import Router from "vue-router";
import VueBreadcrumbs from 'vue-breadcrumbs';

// application configuration
import ProgramInfo from "./views/summaries/ProgramInfo";
import PartnerInfo from "./views/summaries/PartnerInfo.vue";
import PartnerInfoUpload from "@/views/summaries/PartnerInfoUpload.vue";
import InvestmentInfo from "@/views/investment/InvestmentInfo.vue";
import InvestmentUpload from "@/views/investment/InvestmentUpload.vue";

// business events
import InitialIssuance from "@/views/initial-issuance/InitialIssuance.vue";
import IssuanceEvent from "@/views/issuance/IssuanceEvent.vue";
import IssuanceUpload from "@/views/issuance/IssuanceUpload.vue"
import TransferEvent from "@/views/transfer/TransferEvent.vue";
import TransferUpload from "@/views/transfer/TransferUpload.vue";
import VestingEvent from "./views/vesting/VestingEvent.vue"
import VestingBulkUpload from "@/views/vesting/VestingBulkUpload.vue";
import BuyoutEvent from "@/views/buyout/BuyoutEvent.vue";
import BuyoutEventDetail from "@/views/buyout/BuyoutEventDetail.vue";
import Distribution from "@/views/distribution/Distribution.vue";
import DistributionUpload from "@/views/distribution/DistributionUpload.vue"
import CorrectionEvent from "@/views/correction/CorrectionEvent.vue";

// reports
import IssuanceReport from "@/views/issuance/IssuanceReport.vue";
import TransferReport from "@/views/transfer/TransferReport.vue";
import VestingReport from "./views/vesting/VestingReport.vue"
import BuyoutReport from "@/views/buyout/BuyoutReport.vue";
import BuyoutReportDetail from "@/views/buyout/BuyoutReportDetail.vue";
import DistributionReport from "@/views/distribution/DistributionReport.vue";
import CorrectionReport from "@/views/correction/CorrectionReport.vue";
import CorrectionLog from "@/views/correction/CorrectionLog.vue";
import ProgramReport from "./views/reports/ProgramReport.vue";
import PartnerCapitalReport from "./views/reports/PartnerCapitalReport.vue";
import InvestorReport from "./views/investor/InvestorReport.vue";

// valuation
import InvestmentValuation from "@/views/investment/InvestmentValuation.vue";
import InvestmentValuationUpload from "@/views/investment/InvestmentValuationUpload.vue";
import UnitProgramAllocation from '@/views/valuation/UnitProgramAllocation.vue'
import UnitProgramAllocationDetail from '@/views/valuation/UnitProgramAllocationDetail.vue'
import DirectInvestmentValuation from "@/views/valuation/DirectInvestmentValuation.vue";
import DirectInvestmentValuationUpload from "@/views/valuation/DirectInvestmentValuationUpload.vue";

// FMVS
import Footnote from "@/views/fmvs/Footnote.vue";
import FootnoteUpload from "@/views/fmvs/FootnoteUpload.vue";
import FMVSFootnote from '@/views/fmvs/FMVSFootnote.vue';
import FMVSEntry from '@/views/fmvs/FMVSEntryPage.vue';
import FMVSReport from "@/views/fmvs/FMVSReport.vue";
import FMVSReportByTaxId from "@/views/fmvs/FMVSReportByTaxId.vue";
import FMVSBulkProcessing from '@/views/fmvs/FMVSBulkProcessing.vue';
import FMVSBulkProcessingByTaxId from '@/views/fmvs/FMVSBulkProcessingByTaxId.vue';
import Memo from "@/views/fmvs/Memo.vue";

// admin
import InfoTracker from "@/views/admin/InfoTracker.vue";
import InfoTrackerUpload from "@/views/admin/InfoTrackerUpload.vue";
import DocumentDropoff from "@/views/document/DocumentDropoff.vue";
import DocumentManager from "@/views/document/DocumentManager.vue";
import InputControl from '@/views/admin/InputControl.vue';

// other pages
import ComingSoon from "@/views/ComingSoon.vue";
import NotFound from "@/views/NotFound.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import InitialLoad from "@/views/InitialLoad.vue";

// test @delete?
import TestPdf from "@/components/generateFile/TestPdf.vue";

//PBI Report
import report from "@/components/report/report.vue"


Vue.use(Router);
Vue.use(VueBreadcrumbs, {
	template: '<nav class="breadcrumb" v-if="$breadcrumbs.length"> ' +
		'<router-link class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link> ' +
		'</nav>'
});
//console.log("-------------- router.js -----------------");
console.log(`process.env.NODE_ENV = [${process.env.NODE_ENV}]`);
const router = new Router({
	//mode: 'history',
	//base: process.env.NODE_ENV === "production" ? process.env.VUE_APP_siteRelativeUrl + process.env.VUE_APP_appRelativeUrl : "",
	routes: [
		{
			path: "/pagenotfound",
			name: "pagenotfound",
			component: PageNotFound
		},
		{
			path: "/testpdf",
			name: "testpdf",
			component: TestPdf
		},
		{
			path: "/public",
			redirect: () => {
				//if (process.env.VUE_APP_fileFlag === '.env.development'){
					return "/home";
				//}
			}
		},
		{ path: "/initload",
		  name: "initload",
			component: InitialLoad
		},
		{ path: '*', component: NotFound },
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: "/home",
			name: "home",
			redirect: { name: 'ProgramInfoHome' },
			component: { template: "<router-view></router-view>" },
			meta: { breadcrumb: 'Home' },
			children: [
				// {
				// 	path: "/dashboard",
				// 	name: "Dashboard",
				// 	component: report,
				// 	meta: { breadcrumb: 'Dashboard' },
				// },
				{
					path: "/comingsoon",
					name: "ComingSoon",
					component: ComingSoon,
					meta: { breadcrumb: 'ComingSoon' },
				},
				{
					path: '/',
					name: "ProgramInfoHome",
					component: ProgramInfo
				},
				{
					path: "/configuration",
					redirect: '/home',
					name: "Configuration",
					component: { template: "<router-view></router-view>" },
					meta: { breadcrumb: 'Application Configuration' },
					children: [
						{
							path: "program",
							name: "ProgramInfo",
							component: ProgramInfo,
							meta: { breadcrumb: 'Program Information' },
						},
						{
							path: "partner",
							name: "PartnerInfo",
							meta: { breadcrumb: 'Partner Information' },
							component: { template: "<router-view></router-view>" },
							redirect: 'PartnerInfo/',
							children: [
								{
									path: '/',
									component: PartnerInfo,
								},
								{
									path: "Upload",
									name: "PartnerInfoUpload",
									component: PartnerInfoUpload,
									meta: { breadcrumb: 'Partner Information Upload' },
								},
							]
						},
						{
							path: "investment",
							name: "InvestmentInfo",
							meta: { breadcrumb: 'Investment Information' },
							component: { template: "<router-view></router-view>" },
							redirect: 'InvestmentInfo/',
							children: [
								{
									path: '/',
									component: InvestmentInfo,
								},
								{
									path: "upload",
									name: "InvestmentUpload",
									component: InvestmentUpload,
									meta: { breadcrumb: 'Investment Upload' },
								}
							]
						}
					]
				},
				{
					path: "/event",
					redirect: '/home',
					component: { template: "<router-view></router-view>" },
					meta: { breadcrumb: 'Business Events' },
					children: [
						{
							path: "InitialIssuance",
							name: "InitialIssuance",
							component: InitialIssuance,
							meta: { breadcrumb: 'Initial Issuance' },
						},
						{
							path: "issuance",
							name: "IssuanceEvent",
							// component: IssuanceEvent,
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Issuance' },
							redirect: 'issuance/',
							children: [
								{
									path: '/',
									component: IssuanceEvent,
								},
								{
									path: "Upload",
									name: "IssuanceUpload",
									component: IssuanceUpload,
									meta: { breadcrumb: 'Issuance Upload' },
								},
							]
						},
						{
							path: "transfer",
							name: "TransferEvent",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Transfer' },
							redirect: 'transfer/',
							children: [
								{
									path: '/',
									component: TransferEvent,
								},
								{
									path: "Upload",
									name: "TransferUpload",
									component: TransferUpload,
									meta: { breadcrumb: 'Transfer Upload' },
								},
							]
						},
						{
							path: "vesting",
							name: "VestingEvent",
							//component: VestingEvent,
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Vesting' },
							redirect: 'vesting/',
							children: [
								{
									path: '/',
									component: VestingEvent,
								},
								{
									path: "bulkupload",
									name: "VestingBulkUpload",
									component: VestingBulkUpload,
									meta: { breadcrumb: 'Vesting Bulk Upload' },
								},
							]
						},
						{
							path: "buyout",
							name: "BuyoutEvent",
							component: BuyoutEvent,
							meta: { breadcrumb: 'Buyout' },
						},
						{
							path: "buyout/:partnerId?",
							name: "BuyoutEventDetail",
							component: BuyoutEventDetail,
							meta: { breadcrumb: 'Buyout Detail' },
						},
						{
							path: "Distribution",
							name: "Distribution",
							meta: { breadcrumb: 'Distribution' },
							component: { template: "<router-view></router-view>" },
							redirect: 'Distribution/',
							children: [
								{
									path: '/',
									component: Distribution,
								},
								{
									path: "Upload",
									name: "DistributionUpload",
									component: DistributionUpload,
									meta: { breadcrumb: 'Distribution Upload' },
								},
							]
						},
						{
							path: "correction",
							name: "CorrectionEvent",
							component: ComingSoon,
							meta: { breadcrumb: 'Correction' },
						}
					]
				},
				{
					path: "/report",
					redirect: '/home',
					component: { template: "<router-view></router-view>" },
					meta: { breadcrumb: 'Reports & Analytics' },
					children: [
						{
							path: "program/:programId?",
							name: "ProgramReport",
							component: ProgramReport,
							meta: { breadcrumb: 'Program Report' },
						},
						{
							path: "issuance",
							name: "IssuanceReport",
							component: IssuanceReport,
							meta: { breadcrumb: 'Issuance Report' },
						},
						{
							path: "transfer",
							name: "TransferReport",
							component: TransferReport,
							meta: { breadcrumb: 'Transfer Report' },
						},
						{
							path: "vesting",
							name: "VestingReport",
							component: VestingReport,
							meta: { breadcrumb: 'Vesting Report' },
						},
						{
							path: "buyout",
							name: "BuyoutReport",
							component: BuyoutReport,
							meta: { breadcrumb: 'Buyout Report' },
						},
						{
							path: "buyout/:partnerId?",
							name: "BuyoutReportDetail",
							component: BuyoutReportDetail,
							meta: { breadcrumb: 'Buyout Detail' },
						},
						{
							path: "management",
							name: "ManagementReport",
							component: ComingSoon,
							meta: { breadcrumb: 'Management Report' },
						},
						{
							path: "custom",
							name: "CustomReport",
							component: ComingSoon,
							meta: { breadcrumb: 'Custom Report' },
						},
						{
							path: "correction",
							name: "CorrectionReport",
							component: ComingSoon,
							meta: { breadcrumb: 'Correction Report' },
						},
						{
							path: "distribution",
							name: "DistributionReport",
							component: DistributionReport,
							meta: { breadcrumb: 'Distribution Report' },
						},
						{
							path: "correctionlog/:correctionID?",
							name: "CorrectionLog",
							component: ComingSoon,
							meta: { breadcrumb: 'Correction Log' },
						},
						{
							path: "investor/:partnerId?",
							name: "InvestorReport",
							component: InvestorReport,
							meta: { breadcrumb: 'Investor Report' },
						},
						{
							path: "partnercapital",
							name: "PartnerCapitalReport",
							component: PartnerCapitalReport,
							meta: { breadcrumb: 'Partner Capital Activity Report' },
						},
						{
							path: "dashboard",
							name: "Dashboard",
							component: report,
							meta: { breadcrumb: 'Dashboard' },
						}

					]
				},
				{
					path: "/valuation",
					component: { template: "<router-view></router-view>" },
					meta: { breadcrumb: 'Valuations' },
					children: [
						{
							path: "investmentvaluation",
							name: "InvestmentValuation",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Investment Valuation' },
							redirect: 'InvestmentValuation/',
							children: [
								{
									path: '/',
									component: InvestmentValuation
								},
								{
									path: 'upload',
									name: 'InvestmentValuationUpload',
									component: InvestmentValuationUpload,
									meta: { breadcrumb: 'Investment Valuation Upload' },
								}
							]
						},
						{
							path: "directinvestment",
							name: "DirectInvestment",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Direct Investment' },
							redirect: 'DirectInvestment/',
							children: [
								{
									path: '/',
									component: DirectInvestmentValuation
								},
								{
									path: "upload",
									name: "DirectInvestmentValuationUpload",
									component: DirectInvestmentValuationUpload,
									meta: { breadcrumb: 'Direct Investment Valuation Upload' },
								}
							]
						},
						{
							path: "allocation",
							name: "UnitProgramAllocation",
							component: UnitProgramAllocation,
							meta: { breadcrumb: 'Unit Program Allocation' },
						},
						{
							//path: "allocation/:programTitle?/:investmentId?/:taxQuarter?",
							path: "UnitProgramAllocationDetail",
							name: "UnitProgramAllocationDetail",
							component: UnitProgramAllocationDetail,
							meta: { breadcrumb: 'Allocation Detail' },
						},
						{
							path: "footnote",
							name: "Footnotes",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Custom Footnotes' },
							redirect: 'Footnotes/',
							children: [
								{
									path: '/',
									component: Footnote
								},
								{
									path: "upload",
									name: "CustomFootnoteUpload",
									component: FootnoteUpload,
									meta: { breadcrumb: 'Custom Footnote Valuation Upload' },
								}
							]
						},
						{
							path: "fmvs",
							name: "FMVS",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'FMV Statement' },
							redirect: 'fmvs/',
							children: [
								{
									path: '/',
									component: FMVSEntry,
								},
								{
									path: 'Individual',
									component: FMVSReport,
									meta: { breadcrumb: 'Individual Report' }
								},
								{
									path: 'IndividualByTaxId',
									component: FMVSReportByTaxId,
									meta: { breadcrumb: 'Individual Report' }
								},
								{
									path: 'BulkProcessing',
									component: FMVSBulkProcessing,
									meta: { breadcrumb: 'Bulk Processing' }
								},
								{
									path: 'BulkProcessingTaxId',
									component: FMVSBulkProcessingByTaxId,
									meta: { breadcrumb: 'Bulk Processing' }
								},
								{
									path: "footnote",
									name: "footnote",
									component: FMVSFootnote,
									meta: { breadcrumb: 'FMV Statement Footnotes' },
								}
							]
						},
						{
							path: "memo",
							name: "Memo",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Custom Memo' },
							redirect: 'Memo/',
							children: [
								{
									path: '/',
									component: Memo
								}
							]
						},

					]
				},
				{
					path: "/admin",
					component: { template: "<router-view></router-view>" },
					meta: { breadcrumb: 'Administration' },
					children: [
						{
							path: "tracker",
							name: "Tracker",
							component: { template: "<router-view></router-view>" },
							meta: { breadcrumb: 'Information Tracker' },
							redirect: 'tracker/',
							children: [
								{
									path: '/',
									component: InfoTracker,
								},
								{
									path: "Upload",
									name: "InfotrackerUpload",
									component: InfoTrackerUpload,
									meta: { breadcrumb: 'Information Tracker Upload' },
								}
							]
						},
						// {
						// 	path: "tracker",
						// 	name: "Tracker",
						// 	component: InfoTracker,
						// 	meta: { breadcrumb: 'Information Tracker' },
						// },
						{
							path: "InputControl",
							name: "InputControl",
							component: InputControl,
							meta: { breadcrumb: 'Input Control' },
						},

						{
							path: "upload",
							name: "Upload",
							component: DocumentDropoff,
							meta: { breadcrumb: 'Document Upload' },
						},
						{
							path: "document",
							name: "Document",
							component: DocumentManager,
							meta: { breadcrumb: 'Document Manager' },
						},

					]
				}
			]
		},
	]
});
router.beforeEach((to, from, next) => {
	
	if (from.path == '/pagenotfound') {
		next(false)
	} else {
		next()
	}
})
export default router
